<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-8">
            <div class="card rounded-5 p-3 border">
              <div class="card-body form-style">
                <div class="row">
                  <div class="text-center text-lg-left col-lg-8 col-md-7 mb-4">
                    <img
                      :src="user.image ? user.image: '/images/icon_profile.svg'"
                      class="w-2 rounded-circle"
                      alt="image thumb"
                      id="img"
                      width="120"
                      height="120"
                    />
                    <br />
                    <br />
                    <button
                      type="button"
                      class="btn px-3 upload-img-merge-btn rounded-8 btn-outline-primary w-50 text-capitalize"
                    >
                      {{$lang.messages.upload_profile}}
                      <input
                        type="file"
                        class="btn upload-img"
                        id="AddPhoto"
                        accept="image/*"
                        @change="onChange($event)"
                      />
                    </button>
                  </div>
                </div>
                <form data-vv-scope="modifier-form">
                  <div class="col-lg-6 mb-4 px-0">
                    <label for>{{$lang.messages.name}}</label>
                    <span style="color:#ff0000">*</span>
                    <input
                      name="name"
                      v-model="user.name"
                      v-validate="'required|max:300'"
                      maxlength="300"
                      class="form-control mb-3"
                      :class="{'input': true, 'is-danger': errors.has('modifier-form.name') }"
                      type="text"
                      v-bind:placeholder="$lang.messages.name"
                    />
                    <i v-show="errors.has('modifier-form.name')" class="fa fa-warning"></i>
                    <span
                      v-show="errors.has('modifier-form.name')"
                      class="help is-danger"
                    >{{$lang.messages.please_enter_valid_name}}</span>
                    <a
                      v-if="canChangePassword"
                      class="text-primary float-right"
                      @click.prevent="showChangePasswordModal"
                    >{{$lang.messages.change_password}}</a>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 text-lg-right text-center">
            <button
              type="button"
              class="btn btn-primary mr-3"
              @click="validateForm()"
            >{{$lang.messages.save_btn_text}}</button>
            <button
              type="button"
              class="btn btn-outline-primary"
              @click="getMe()"
            >{{$lang.messages.cancel_btn_text}}</button>
          </div>
        </div>
      </div>
    </div>

    <a
      v-if="canChangePassword"
      data-toggle="modal"
      data-target="#ChangePassword"
      ref="ChangePasswordLink"
      style="display: block" />

    <div
      v-if="canChangePassword"
      class="modal fade"
      id="ChangePassword"
      tabindex="-1"
      role="dialog"
      aria-labelledby="ChangePassword"
      ref="changePasswordForm"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content px-lg-4 py-lg-4">
          <div class="modal-header border-0">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <h5 class="modal-title font-22 text-center mb-2">{{ $lang.messages.change_password }}</h5>

          <form @submit.prevent="onUpdateEmployeePassword" class="form-style" data-vv-scope="employeeChangePasswordForm">
            <div class="form-group">
              <label>{{ $lang.messages.old_password }}</label>

              <div class="input-group show_hide_password">
                <input
                  name="old_password"
                  v-model="employeeChangePassword.old_password"
                  class="input form-control"
                  v-validate="'required'"
                  :class="{'input':true, 'is-danger': errors.has('employeeChangePasswordForm.old_password') }"
                  type="password"
                />
                <div class="input-group-addon border border-left-0 py-1 px-2 border-secondary bg-light">
                  <a href style="vertical-align: sub;">
                    <i class="fa fa-eye-slash" aria-hidden="true"></i>
                  </a>
                </div>
              </div>

              <i v-show="errors.has('employeeChangePasswordForm.old_password')" class="fa fa-warning"></i>
              <span
                v-show="errors.has('employeeChangePasswordForm.old_password')"
                class="help is-danger"
              >{{ $lang.messages.please_enter_old_password }}</span>
            </div>

            <div class="form-group">
              <label>{{ $lang.messages.new_password }}</label>
              <div class="input-group show_hide_password">
                <input
                  ref="employeePassword"
                  name="new_password"
                  v-model="employeeChangePassword.new_password"
                  class="input form-control"
                  v-validate="'required'"
                  :class="{'input':true, 'is-danger': errors.has('employeeChangePasswordForm.new_password') }"
                  type="password"
                />

                <div class="input-group-addon border border-left-0 py-1 px-2 border-secondary bg-light">
                  <a href style="vertical-align: sub;">
                    <i class="fa fa-eye-slash" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
              <i v-show="errors.has('employeeChangePasswordForm.new_password')" class="fa fa-warning"></i>
              <span
                v-show="errors.has('employeeChangePasswordForm.new_password')"
                class="help is-danger"
              >{{ $lang.messages.please_enter_new_password }}</span>
            </div>

            <div class="form-group">
              <label>{{ $lang.messages.confirm_password }}</label>
              <div class="input-group show_hide_password">
                <input
                  name="confirm_password"
                  v-model="employeeChangePassword.confirm_password"
                  class="input form-control"
                  v-validate="'required|confirmed:employeePassword'"
                  :class="{'input':true, 'is-danger': errors.has('employeeChangePasswordForm.confirm_password') }"
                  type="password"
                />

                <div class="input-group-addon border border-left-0 py-1 px-2 border-secondary bg-light">
                  <a href style="vertical-align: sub;">
                    <i class="fa fa-eye-slash" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
              <i v-show="errors.has('employeeChangePasswordForm.confirm_password')" class="fa fa-warning"></i>
              <span
                v-show="errors.has('employeeChangePasswordForm.confirm_password')"
                class="help is-danger"
              >{{ $lang.messages.please_enter_confirm_password }}</span>
            </div>

            <div class="form-group text-center">
              <button type="submit" class="btn btn-primary d-block" style="width: 100%">{{ $lang.messages.save }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import ErrorComponent from "@/components/ErrorComponent";
import Alert from "@/components/Alert";
import router from "../../router";
import EventBus from "../../eventBus";
export default {
  name: "Customers",
  components: {
    Pagination,
    ErrorComponent,
    Alert
  },
  data() {
    return {
      employeeChangePassword: {
        old_password: '',
        new_password: '',
        confirm_password: ''
      },
      user: {
        id: "",
        name: "",
        email: "",
        phone_number: "",
        image: "",
      },
      showPass: false,
      file: null,
      filterObj: {
        sort_by: "",
        order_by: "ASC",
        search: ""
      },
      canChangePassword: true,
    };
  },

  methods: {
    getMe() {
      this.$api
        .getAPI({
          _action: `/me?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}`
        })
        .then(res => {
          if (res.days) {
            localStorage.setItem("days", res.days);
          }
          this.user = res.user;
          this.user.id = res.user.id;
          this.user.name = res.user.name;
          this.user.email = res.user.email;
          this.user.phone_number = res.user.phone_number;
          this.user.image = res.user.image;

          if (this.user.role_name === 'OWNER') this.canChangePassword = false
        });
    },

    Cancel() {
      router.push("/profile");
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.add();
          return;
        }
      });
    },

    validateForm() {
      this.$validator.validateAll("modifier-form").then(result => {
        if (result) {
          this.save();
          return;
        }
      });
    },

    save() {
      this.$api
        .postAPI({
          _action: "/update_name/" + this.user.id,
          _body: this.user,
          _buttonId: "save-btn"
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });
          document.getElementById("cancel-btn").click();
        })
        .catch(e => {
          console.log(e.message);
        });
    },

    add() {
      this.$api
        .postAPI({
          _action: "/change_password_bo",
          _body: this.user,
          _buttonId: "save-btn"
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });
          localStorage.clear();
          this.$shareService.clearMap();
          router.push("/login");
          document.getElementById("cancel-btn").click();
        })
        .catch(e => {
          // console.log(e.message);
        });
    },

    onChange(e) {
      let files = e.target.files;
      this.file = files[0];
      if (e.target.files && e.target.files[0]) {
        var reader = new FileReader();
        reader.onload = function(e) {
          $("#img").attr("src", e.target.result);
        };
      }
      reader.readAsDataURL(e.target.files[0]);
      this.uploadFile();
    },

    sendData() {
      const payload = {
        action: "test"
      };
      EventBus.$emit("DATA_PUBLISHED", payload);
    },

    uploadFile() {
      this.$api
        .uploadImageAPI({
          _action: "/upload_user_image",
          _key: "image",
          _file: this.file
        })
        .then(res => {
          this.sendData();
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });
        });
    },

    onUpdateEmployeePassword() {
      this.$validator.validateAll('employeeChangePasswordForm').then(result => {
        if (!result) return

        this.$api
          .postAPI({
            _action: '/employee/change_password',
            _body: this.employeeChangePassword
          })
          .then(res => {
            this.$notify({
              group: 'foo',
              text: res.message,
              type: 'success'
            })

            $("#ChangePassword").modal("hide");
            this.employeeChangePassword = {
              old_password: '',
              new_password: '',
              confirm_password: ''
            }
          })
          .catch(error => {
            console.log(error)
          })
      })
    },

    showChangePasswordModal() {
      this.$refs.ChangePasswordLink.click();
      this.toggleShowHidePassword()
    },

    toggleShowHidePassword() {
      $(document).ready(function() {
        $('.show_hide_password').each(function() {
          var $this = $(this)

          $this.find('a').on('click', function(event) {
            event.preventDefault()
            if ($this.find('input').attr('type') == 'text') {
              $this.find('input').attr('type', 'password')
              $this.find('i').addClass('fa-eye-slash')
              $this.find('i').removeClass('fa-eye')
            } else if ($this.find('input').attr('type') == 'password') {
              $this.find('input').attr('type', 'text')
              $this.find('i').removeClass('fa-eye-slash')
              $this.find('i').addClass('fa-eye')
            }
          })
        })
      })
    }
  },

  mounted() {
    $(".search-box a, .search-box .app-search .srh-btn").on(
      "click",
      function() {
        $(".app-search").toggle(200);
        $(".app-search input").focus();
      }
    );

    this.getMe();
  }
};
</script>
